"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reduxOrm = require("redux-orm");

var _models = require("./models");

var orm = new _reduxOrm.ORM({
  stateSelector: function stateSelector(state) {
    return state.MenuBuilderComponent;
  }
});
orm.register(_models.Banner, _models.BannerGroup, _models.Menu);
var _default = orm;
exports["default"] = _default;